<section translate="no">
  <section style="height: auto;">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                Cadastro de Indicadores
              </td>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  <main id="sessao_topo_tela" class="div_orientacao">
    <span>Cores das Sessões: (click para atalho)</span>
    <div style="display: flex; justify-content: space-around;flex-wrap: wrap;">

      <div class="legenda" (click)="irPara('sessao_multi_valor')">
        <div class="cor" [style.background-color]="CorMultValor"></div>
        <span>Valor Indicador Multiplas Consultas</span>
      </div>
      <div class="legenda" (click)="irPara('sessao_campos')">
        <div class="cor" [style.background-color]="CorCampos"></div>
        <span>Campos</span>
      </div>
      @if(novoItem.etapa!=3){
      <div class="legenda" (click)="irPara('sessao_cabecalho_especial')">
        <div class="cor" [style.background-color]="CorCabecalhoEspecial"></div>
        <span>Cabeçalho Especial</span>
      </div>
      }

      <div class="legenda" (click)="irPara('sessao_calculo_cor')">
        <div class="cor" [style.background-color]="CorCalculoCor"></div>
        <span>Calculo de Cor</span>
      </div>

      <div class="legenda" (click)="irPara('sessao_cor_farol')">
        <div class="cor" [style.background-color]="CorFarol"></div>
        <span>Farol</span>
      </div>
    </div>
    <section class="main-section">
      <form class="form-class" data-toggle="collapse">
        <input type="text" class="form-control" id="id" name="id" [(ngModel)]="novoItem.id" required
          style="display: none;">
        <div class="form-div p-3">
          <label for="etapa" class="form-label">Etapa <span class="required">* </span> <span
              matTooltip="Qual etapa do indicador"><i class="fas fa-question-circle"> </i></span></label>
          <fieldset class="fieldInput">
            <input type="number" class="form-control form-input" [readonly]="TravaEtapa"
              [ngClass]="{'readonly': TravaEtapa, 'editable': !TravaEtapa}" (input)="handleInputChange($event)"
              id="etapa" name="etapa" [(ngModel)]="novoItem.etapa" required>
            <button type="submit" (click)="alterarTravaEtapa(!TravaEtapa)" class="form-submit"><i *ngIf="TravaEtapa"
                class="fas fa-lock"></i><i *ngIf="!TravaEtapa" class="fas fa-lock-open"></i></button>
          </fieldset>
        </div>
        <div class="form-div p-3">
          <label for="proximaEtapa" class="form-label">Próxima Etapa <span
              matTooltip="Se refere a próxima Etapa do indicador"><i class="fas fa-question-circle"> </i></span></label>
          <input type="number" class="form-control" id="proximaEtapa" name="proximaEtapa"
            [(ngModel)]="novoItem.proximaEtapa" required>
        </div>
        <div class="form-div form-check form-switch">
          <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.ehGraficoIndicador"
            name="ehGraficoIndicador" id="ehGraficoIndicador">
          <label class="form-check-label" for="flexCheckDefault">
            é um tipo de indicador especial? <span matTooltip="Quando tem a etapa fila "><i
                class="fas fa-question-circle"> </i></span>
          </label>
        </div>
        <div class="form-div p-3" *ngIf="novoItem.ehGraficoIndicador">
          <label for="tipoGraficoIndicador" class="form-label">Tipo do Gráfico <span class="required">*</span> <span
              matTooltip="Tipo de gráfico "><i class="fas fa-question-circle"> </i></span></label>
          <select class="form-select" [(ngModel)]="novoItem.tipoGraficoIndicador" name="tipoGraficoIndicador">
            <option *ngFor="let tipoGI of optionsTipoGraficoIndicador" [value]="tipoGI.value">{{ tipoGI.label }}
            </option>
          </select>
        </div>
        <div class="form-div p-3" [style.display]="EhEtapa1 ? 'none' : 'block'">
          <label for="indicador" class="form-label">Indicador <span matTooltip="Indicador que faz parte dessa etapa "><i
                class="fas fa-question-circle"> </i></span></label>
          <select #mySelectIndicador name="select" class="form-select"
            (change)="onOptionChange(mySelectIndicador.value)">
            <option value="">Escolha o Indicador</option>
            <option *ngFor="let objeto of listaIndEtapa1" value={{objeto.codigo}}>{{objeto.nome}}</option>
          </select>
        </div>

        @if(EhEtapa1)
        {
        <div class="form-div p-3">
          <label for="codigo" class="form-label">Codigo <span class="required">* </span> <span
              matTooltip="Código do indicador"><i class="fas fa-question-circle"> </i></span></label>
          <input type="number" class="form-control" id="codigo" name="codigo" [(ngModel)]="novoItem.codigo" required>
        </div>
        <div class="form-div p-3">
          <label for="nome" class="form-label">Nome <span class="required">* </span> <span
              matTooltip="Nome do indicador"><i class="fas fa-question-circle"> </i></span></label>
          <input type="text" class="form-control" id="nome" name="nome" [(ngModel)]="novoItem.nome" required>
        </div>
        <div class="form-div p-3">
          <label for="descricao" class="form-label">Descricao <span class="required">* </span> <span
              matTooltip="Descrição do indicador"><i class="fas fa-question-circle"> </i></span></label>
          <input type="text" class="form-control" id="descricao" name="descricao" [(ngModel)]="novoItem.descricao"
            required>
        </div>
       
        <div class="form-div p-3">
          <label for="icone" class="form-label">Ícone <span matTooltip="Ícone do indicador "><i
                class="fas fa-question-circle"> </i></span></label>
          <input type="text" class="form-control" id="icone" name="icone" [(ngModel)]="novoItem.icone" required>
        </div>
        <div class="form-div p-3">
          <label for="abreviatura" class="form-label">Abreviatura <span matTooltip="Nome abreviado do indicador"><i
                class="fas fa-question-circle"> </i></span></label>
          <input type="text" class="form-control" id="abreviatura" name="abreviatura" [(ngModel)]="novoItem.abreviatura"
            required>
        </div>
        <div class="form-div p-3">
          <label for="ordemDashboard" class="form-label">Ordem no Dashboard <span
              matTooltip="Ordem do indicador no Dashboard inicial"><i class="fas fa-question-circle">
              </i></span></label>
          <input type="number" class="form-control" id="ordemDashboard" name="ordemDashboard"
            [(ngModel)]="novoItem.ordemDashboard" required readonly>
        </div>

        <div class="form-div p-3">
          <label for="editorHtml" class="form-label">Editar Texto Ajuda <span
              matTooltip="Texto que será mostrado no ajuda desse indicador referente ao cálculo e as cores"><i
                class="fas fa-question-circle"> </i></span></label>
          <quill-editor [modules]="editorConfig" class="form-control" id="textoAjudaHTML" name="textoAjuda"
            [(ngModel)]="novoItem.textoAjudaHTML"></quill-editor>
        </div>
        }
        
        <!-- @else if(novoItem.tipoGraficoIndicador == 4)
        {
        <div class="form-div p-3">
          <label for="tempoAtualizacao" class="form-label">Tempo Atualização <span
              matTooltip="Tempo de Atualização do indicador na tela "><i class="fas fa-question-circle">
              </i></span></label>
          <input type="number" class="form-control" id="tempoAtualizacao" name="tempoAtualizacao"
            [(ngModel)]="novoItem.tempoAtualizacao" required>
        </div>
        } -->
        <div class="form-div p-3">
          <label for="tempoAtualizacao" class="form-label">Tempo Atualizacao <span
              matTooltip="Tempo de Atualização do indicador na tela "><i class="fas fa-question-circle">
              </i></span></label>
          <input type="number" class="form-control" id="tempoAtualizacao" name="tempoAtualizacao"
            [(ngModel)]="novoItem.tempoAtualizacao" required>
        </div>



        <div class="form-div p-3">
          <label for="nomeTipoTela" class="form-label">Nome do Tipo da Tela <span matTooltip="Nome do tipo da tela  "><i
                class="fas fa-question-circle"> </i></span></label>
          <input type="text" class="form-control" id="nomeTipoTela" name="nomeTipoTela"
            [(ngModel)]="novoItem.nomeTipoTela" required>
        </div>
        <div class="form-div p-3">
          <label for="linkRedirect" class="form-label">Link para Redirect Padrão <span
              matTooltip="Redireciona a tela para um link padrão"><i class="fas fa-question-circle"> </i></span></label>
          <input type="text" class="form-control" id="linkRedirect" name="linkRedirect"
            [(ngModel)]="novoItem.linkRedirect" required>
        </div>
        <div class="form-div p-3">
          <label for="visualizacaoDisplay" class="form-label">Visualização Display <span
              matTooltip="Se você deseja que o card seja exibido no formato extenso ou vertical, adicione 'content' ou 'flex' no campo abaixo. (Observação: o estilo só será aplicado se o tipo de tela for 'Fila')."><i
                class="fas fa-question-circle"> </i></span></label>
          <input type="text" class="form-control" id="visualizacaoDisplay" name="visualizacaoDisplay"
            [(ngModel)]="novoItem.visualizacaoDisplay" required>
        </div>
        <div style="display: flex; justify-content: right;">
          <button (click)="mudarMultiConsultaValor(true)" *ngIf="!EhMultiConsultaValor" id="sessao_multi_valor"
            class="btn btn-secondary" matTooltip="Caso seja Múltiplas consultas">Abrir Múltiplas
            Consultas</button>
          <button (click)="mudarRegistroComCampos(true)" id="sessao_campos" *ngIf="!EhRegistroComCampos"
            class="btn btn-secondary" style="margin-left: 15px;" matTooltip="criação de campos ">Abrir Campos</button>
        </div>
        <ng-container *ngIf="!EhMultiConsultaValor">
          <div style="display: flex; justify-content: right; margin-top: 15px;">
            <button (click)="validateAndFormat(0, 'Valor')" class="btn btn-secondary"
              matTooltip="Esse botão verifica se o formato da consulta é um json válido">Validar e Formatar
              JSON</button>
          </div>



          <div class="form-div p-3">
            <label for="consulta" class="form-label">Consulta <span
                matTooltip=" Parâmetros, variável, alterando, número, necessário"><i class="fas fa-question-circle">
                </i></span></label>
            <textarea type="text" class="form-control" id="consulta" name="consulta" [(ngModel)]="novoItem.consulta"
              required></textarea>
            <div id="consultaHelpBlock" class="form-text">
              Utilize esses parâmentros para indicar data: #sc:inicio_dia#; #sc:fim_dia#; #sc:data_atual#; ou
              filtrar por id: #sc:id#;<br />
              A variavel #sc:data_atual# pode ser implementada como #sc:data_atual-Xh#, #sc:data_atual+Xmin#,
              #sc:data_atual-Xs# altereando o X para um número necessário.
            </div>
          </div>
        </ng-container>
        <div *ngIf="EhMultiConsultaValor" id="sessao_multi_valor" [style.background-color]="CorMultValor"
          style="color: black">
          <hr>
          <label for="calculoCores" class="form-label">Cálculo de Valor: <span
              matTooltip="Calculo que será feito para mostrar no indicador"><i
                class="fas fa-question-circle"></i></span></label>
          <div *ngFor="let consulta of consultasValor; let i = index">
            <label for="consulta" class="form-label">Consulta {{i+1}}</label>
            <div class="form-div p-3">
              <label for="nome" class="form-label">Nome: <span
                  matTooltip="Nome do campo que está retornando da query"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="v_nome_{{i}}" name="v_nome_{{i}}" [(ngModel)]="consulta.nome"
                required>
            </div>
            <div class="form-div p-3">
              <label for="nome" class="form-label">Índice: <span matTooltip="Qual o nome do indice no banco"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="v_indice_{{i}}" name="v_indice_{{i}}"
                [(ngModel)]="consulta.indice" required>
            </div>
            <div style="display: flex; justify-content: right; margin-top: 15px;">
              <button (click)="validateAndFormat(i, 'MultiValor')" class="btn btn-secondary"
                matTooltip="Validar o formato json é válido">Validar e Formatar
                JSON</button>
            </div>
            <div class="form-div p-3">
              <label for="consulta" class="form-label">Consulta: <span
                  matTooltip="Criação da consulta Elasticsearch com paremetros  de data inicio e data fim e alguns parametros descrito abaixo "><i
                    class="fas fa-question-circle"></i></span></label>
              <textarea class="form-control" id="v_consulta_{{i}}" name="v_consulta_{{i}}"
                [(ngModel)]="consulta.consulta" required></textarea>
              <div id="consultaHelpBlock1" class="form-text">
                Utilize esses parâmentros para indicar data: #sc:inicio_dia#; #sc:fim_dia#; #sc:data_atual#; ou para
                filtrar por id: #sc:id#;<br />
                A variavel #sc:data_atual# pode ser implementada como #sc:data_atual-Xh#, #sc:data_atual+Xmin#,
                #sc:data_atual-Xs# altereando o X para um número necessário.
              </div>
            </div>
            <div class="form-div p-3">
              <label for="tipoResultado" class="form-label">Tipo Resultado <span matTooltip="Qual tipo de retorno ex: hora, minuto % ou somente a key específica, 
                você também pode escolher o retorno em minutos ou milesegundos dependendo do retorno da query "><i
                    class="fas fa-question-circle"></i></span></label>
              <select class="form-select" [(ngModel)]="consulta.tipoResultado" name="v_tipoResultado_{{i}}">
                <option *ngFor="let tipoResultado of options" [value]="tipoResultado.value">{{ tipoResultado.label }}
                </option>
              </select>
            </div>
            <button (click)="removerConsultaValor(i)" class="btn btn-secondary" matTooltip="Remover a consulta atual"
              style="margin-left: 15px;margin-right: 15px;" matTooltip="Remover essa consulta">Remover Consulta</button>
            <hr>
          </div>
          <div class="form-div p-3">
            <label for="formulaValor" class="form-label">Formula para o Cálculo de Valor: <span
                matTooltip="Formula para o cálculo do indicador "><i class="fas fa-question-circle"></i></span></label>
            <input type="text" class="form-control" id="formulaValor" name="formulaValor"
              [(ngModel)]="novoItem.formulaValor" required>
          </div>
          <button (click)="adicionarConsultaValor()" class="btn btn-info" style="margin-left: 15px;"
            matTooltip="Adicionar nova consulta">Adicionar
            Consulta</button>
          <button (click)="mudarMultiConsultaValor(false)" *ngIf="EhMultiConsultaValor" class="btn btn-danger"
            matTooltip="Cancelar multiplas consultas" style="margin-left: 15px;margin-right: 15px;">Cancelar Multiplas
            Consultas</button>

        </div>
        <div *ngIf="EhRegistroComCampos" id="sessao_campos" [style.background-color]="CorCampos" style="color: black">
          <hr>
          <label for="calculoCores" class="form-label">Campos da Consulta:</label>
          <div *ngFor="let consulta of campos; let i = index">
            <label for="consulta" class="form-label">Campo {{i+1}} </label>
            <div class="form-div p-3">
              <label for="nome" class="form-label">Nome: <span matTooltip="Nome do campo que será mostrado"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="cp_nome_{{i}}" name="cp_nome_{{i}}"
                [(ngModel)]="consulta.nome" required>
            </div>
            <ng-container *ngIf="EhMultiConsultaValor">
              <div class="form-div p-3">
                <label for="nomeConsultaRefentente" class="form-label">Consulta Referente: <span
                    matTooltip="esxcolha a consulta"><i class="fas fa-question-circle"></i></span></label>
                <select class="form-select" [(ngModel)]="consulta.nomeConsultaRefentente"
                  name="cp_nomeConsultaRefentente_{{i}}">
                  <option *ngFor="let tgc of consultasValor" [value]="tgc.nome">{{ tgc.nome }}
                  </option>
                  <option value="MultiConsulta">Ambas Consultas</option>
                </select>
              </div>
            </ng-container>
            <div class="form-div p-3  div-lista-campos-switch">
              <div class="form-div form-check form-switch switch-primeiro">
                <input class="form-check-input" type="checkbox" [(ngModel)]="consulta.naoMostraCampo"
                  name="cp_naomostraCampo_{{i}}" id="cp_naomostraCampo_{{i}}">
                <label class="form-check-label" for="flexCheckDefault">
                  Não mostrar o Campo na tela <span matTooltip="O campo não será mostrado na tela do indicador  "><i
                      class="fas fa-question-circle"></i></span>
                </label>
              </div>
              <div class="form-div form-check form-switch" style="margin-left: 10px;">
                <input class="form-check-input" type="checkbox" [(ngModel)]="consulta.naoMostraTitulo"
                  name="cp_naomostratitulo_{{i}}" id="cp_naomostratitulo_{{i}}">
                <label class="form-check-label" for="flexCheckDefault">
                  Não mostrar o Titulo na tela <span matTooltip="O Título não será mostrado na tela do indicador  "><i
                      class="fas fa-question-circle"></i></span>
                </label>
              </div>
              <div class="form-div form-check form-switch" style="margin-left: 10px;">
                <input class="form-check-input" type="checkbox" [(ngModel)]="consulta.ehComponenteGrafico"
                  name="cp_ehcomponentegrafico_{{i}}" id="cp_ehcomponentegrafico_{{i}}">
                <label class="form-check-label" for="flexCheckDefault">
                  É um componente Gráfico <span matTooltip="Dar check se o componente que será mostrado é gráfico "><i
                      class="fas fa-question-circle"></i></span>
                </label>
              </div>
              <div class="form-div form-check form-switch" style="margin-left: 10px;">
                <input class="form-check-input" type="checkbox" [(ngModel)]="consulta.ehLink" name="cp_ehlink_{{i}}"
                  id="cp_ehlink_{{i}}">
                <label class="form-check-label" for="flexCheckDefault">
                  É um Link <span matTooltip="Dar check se for um link"><i class="fas fa-question-circle"></i></span>
                </label>
              </div>
              <div class="form-div form-check form-switch" style="margin-left: 10px;">
                <input class="form-check-input" type="checkbox" [(ngModel)]="consulta.ehCampoCabecalho"
                  name="cp_ehCampoCabecalho_{{i}}" id="cp_ehCampoCabecalho_{{i}}">
                <label class="form-check-label" for="flexCheckDefault">
                  É o cabeçalho <span matTooltip="Dar check se for um cabeçalho"><i
                      class="fas fa-question-circle"></i></span>
                </label>
              </div>
              <div *ngIf="consulta.tipoValorGrafico == 5" class="form-div form-check form-switch"
                style="margin-left: 10px;">
                <input class="form-check-input" type="checkbox" [(ngModel)]="consulta.ehOcultoPadrao"
                  name="cp_ehOcultoPadrao_{{i}}" id="cp_ehOcultoPadrao_{{i}}">
                <label class="form-check-label" for="flexCheckDefault">
                  Oculto por padrão? <span matTooltip="Dar check se a informação for oculta por padrão"><i
                      class="fas fa-question-circle"></i></span>
                </label>
              </div>
              <div class="form-div form-check form-switch" style="margin-left: 10px;">
                <input class="form-check-input" type="checkbox" [(ngModel)]="consulta.ehCampoOrdenacao"
                  name="cp_ehCampoOrdenacao_{{i}}" id="cp_ehCampoOrdenacao_{{i}}">
                <label class="form-check-label" for="flexCheckDefault">
                  É o Campo de Ordenação? <span matTooltip="Dar check se o campo for de ordenação"><i
                      class="fas fa-question-circle"></i></span>
                </label>
              </div>
            </div>
            <ng-container *ngIf="consulta.ehComponenteGrafico">
              <div style="display: flex; justify-content: right; margin-top: 15px;">
              <button (click)="validateAndFormat(i, 'CAMPO')" class="btn btn-secondary" matTooltip="Validação do formato json">Validar e Formatar
                JSON</button></div>
              <div class="form-div p-3">
                <label for="componenteGraficoHtml" class="form-label">Html do Componente Grafico: <span
                    matTooltip="Adicione o código Html"><i class="fas fa-question-circle"></i></span></label>
                <textarea type="text" class="form-control" id="cp_componenteGraficoHtml_{{i}}"
                  name="cp_componenteGraficoHtml_{{i}}" [(ngModel)]="consulta.componenteGraficoHtml"
                  required></textarea>
                <div id="consultaHelpBlock1" class="form-text">Exemplo: {{HTMLPadrao}}</div>
              </div>
              <div class="form-div p-3">
                <label for="componenteGraficoCss" class="form-label">Css do Componente Grafico: <span
                    matTooltip="Adicione o código CSS para o estilo"><i
                      class="fas fa-question-circle"></i></span></label>
                <textarea type="text" class="form-control" id="cp_componenteGraficoCss_{{i}}"
                  name="cp_componenteGraficoCss_{{i}}" [(ngModel)]="consulta.componenteGraficoCss" required></textarea>
              </div>
              <div class="form-div p-3">
                <label for="componenteGraficoPossicao" class="form-label">Possição do Componente Grafico: <span
                    matTooltip="Posição do componente grafico"><i class="fas fa-question-circle"></i></span></label>
                <input type="text" class="form-control" id="cp_componenteGraficoPossicao_{{i}}"
                  name="cp_componenteGraficoPossicao_{{i}}" [(ngModel)]="consulta.componenteGraficoPossicao" required>
                <div id="consultaHelpBlock1" class="form-text">Exemplo: {{PossicaoPadrao}}</div>
              </div>
            </ng-container>
            <div class="form-div p-3">
              <label for="tipoValorGrafico" class="form-label">Tipo Identificação Gráfico</label>
              <select class="form-select" [(ngModel)]="consulta.tipoValorGrafico" name="cp_tipoValorGrafico_{{i}}">
                <option *ngFor="let tgc of optionsTipoGraficoCampo" [value]="tgc.value">{{ tgc.label }}
                </option>
              </select>
            </div>
            <ng-container *ngIf="consulta.ehLink">
              <div class="form-div p-3">
                <label for="linkRedirect" class="form-label">Link de Redirect: <span matTooltip="Link para Redirect"><i
                      class="fas fa-question-circle"></i></span></label>
                <input type="text" class="form-control" id="cp_linkRedirect_{{i}}" name="cp_linkRedirect_{{i}}"
                  [(ngModel)]="consulta.linkRedirect" required>
              </div>
              <div style="display: flex; justify-content: right; margin-top: 15px;">
              <button (click)="validateAndFormat(i, 'CAMPO_LINK')" class="btn btn-secondary" matTooltip="Validar se o json é válido ">Validar e Formatar
                JSON</button></div>
              <div class="form-div p-3">
                <label for="linkVariaveis" class="form-label">Variaveis para enviar ao Link: <span
                    matTooltip="Se necessario adicione paramentros ao link"><i
                      class="fas fa-question-circle"></i></span></label>
                <textarea type="text" class="form-control" id="cp_linkVariaveis_{{i}}" name="cp_linkVariaveis_{{i}}"
                  [(ngModel)]="consulta.linkVariaveis" required></textarea>
                <div id="consultaHelpBlock1" class="form-text">Exemplo: {{PossicaoPadrao}}</div>
              </div>
            </ng-container>
            <div class="form-div p-3">
              <label for="icone" class="form-label">Ícone: <span matTooltip="Adicionar a tag do ícone "><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="cp_icone_{{i}}" name="cp_icone_{{i}}"
                [(ngModel)]="consulta.icone" required>
            </div>
            <div class="form-div p-3">
              <label for="campoCalculo" class="form-label">Cálculo Do Campo: <span
                  matTooltip="Cálculo que será feito com base no retorno da query"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="cp_campoCalculo_{{i}}" name="cp_campoCalculo_{{i}}"
                [(ngModel)]="consulta.campoCalculo" required>
            </div>
            <div class="form-div p-3">
              <label for="ordem" class="form-label">Ordem Do Campo: <span
                  matTooltip="Ordenação em que essa informação irá ficar "><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="number" class="form-control" id="cp_ordem_{{i}}" name="cp_ordem_{{i}}"
                [(ngModel)]="consulta.ordem" required>
            </div>

            <div class="form-div p-3">
              <label for="loopingPai" class="form-label">Está abaixo Do Looping: <span
                  matTooltip="Ex: está abaixo do buckets"><i class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="cp_loopingPai_{{i}}" name="cp_loopingPai_{{i}}"
                [(ngModel)]="consulta.loopingPai" required>
            </div>
            <div class="form-div p-3">
              <label for="tipoResultado" class="form-label">Tipo Resultado <span
                  matTooltip="Escolha o tipo de resultado Ex: hora, texto, porcentagem de acordo com que está retornando da query"><i
                    class="fas fa-question-circle"></i></span></label>
              <select class="form-select" [(ngModel)]="consulta.tipoResultado" name="cp_tipoResultado_{{i}}">
                <option *ngFor="let tipoResultado of optionsCampos" [value]="tipoResultado.value">{{ tipoResultado.label
                  }}</option>
              </select>
            </div>
            <div class="form-div p-3">
              <label for="orientacaoLoop" class="form-label">Orientação do Looping <span
                  matTooltip="Qual a Orientação que a informação será mostrada no gráfico Ex : vertical ou horizontal"><i
                    class="fas fa-question-circle"></i></span><span class="required"
                  *ngIf="consulta.tipoResultado == 20">*</span></label>
              <select class="form-select" [(ngModel)]="consulta.orientacaoLoop" name="cp_orientacaoLoop_{{i}}">
                <option value=""></option>
                <option value="VERTICAL">Vertical (em pé)</option>
                <option value="HORIZONTAL">Horizontal (deitado)</option>
              </select>
            </div>
            <button (click)="removerCampo(i)" class="btn btn-secondary" style="margin-left: 15px;margin-right: 15px;"
              matTooltip="Para remover esse campo, basta o click no botão">Remover Campo</button>
            <hr>
          </div>
          <button (click)="adicionarCampo()" class="btn btn-info" style="margin-left: 15px;"
            matTooltip="Esse botão serve para adicionar mais um campo">Adicionar Campo</button>
          <button (click)="AbrirCopia()" class="btn btn-info" style="margin-left: 15px;">Copiar Campos de outro
            Indicador</button>
          <div class="form-div p-3" [style.display]="EhCopiaCampo ? 'block' : 'none'">
            <label for="indicador" class="form-label">De qual Indicador vai copiar? <span
                matTooltip="Se já tiver um indicador com essa informação feita, vc pode apenas copiar escolhendo o indicador"><i
                  class="fas fa-question-circle"></i></span></label>
            <select #mySelectIndicadorCopia name="select" class="form-select"
              (change)="onOptionChangeCopiaCampo(mySelectIndicadorCopia.value)">
              <option value="">Escolha o Indicador</option>
              <option *ngFor="let objeto of listaIndAllEtapas" value={{objeto.id}}>{{objeto.etapa}} - {{objeto.nome}}
              </option>

            </select>
            <button (click)="CopiarCampo()" class="btn btn-info"
              matTooltip="Esse botão serve para efetuar a copia">Copiar Campos</button>
          </div>
          <button (click)="mudarRegistroComCampos(false)" *ngIf="EhRegistroComCampos" class="btn btn-danger"
            style="margin-left: 15px;margin-right: 15px;"
            matTooltip="Esse botão serve para cancelar as informações que estão sendo inseridas, caso não tenha salvo ainda ">Cancelar
            Registro de Campos</button>


        </div>

        <div class="form-div p-3">
          <label for="parametro" class="form-label">Parâmetro <span
              matTooltip="Defina a faixa de cores e, se necessário, adicione parâmetro de data de início e fim.
            { valor: 'valor', tipo: 'hora', vazio: 0, faixa_b: 10, faixa_c: 15, cor: 'azul', show_cor_a: true, cor_a: 'verde', cor_b: 'amarelo', cor_c: 'vermelho', max_faixa_c: 40, script: { inicio_dia: 'inicioDia()', fim_dia: 'fimDia()' } }"><i
                class="fas fa-question-circle"></i></span></label>
          <input type="text" class="form-control" id="parametro" name="parametro" [(ngModel)]="novoItem.parametro"
            required>
        </div>
        <div class="form-div p-3">
          <label for="colecao" class="form-label">Coleção <span matTooltip="Nome do index do indicador"><i
                class="fas fa-question-circle"></i></span></label>
          <input type="text" class="form-control" id="colecao" name="colecao" [(ngModel)]="novoItem.colecao" required>
        </div>
        <div class="form-div p-3">
          <label for="versaoIndice" class="form-label">Versao Índice <span
              matTooltip="Qual a versão do Índice que você está utilizando "><i
                class="fas fa-question-circle"></i></span></label>
          <input type="text" class="form-control" id="versaoIndice" name="versaoIndice"
            [(ngModel)]="novoItem.versaoIndice" required>
        </div>
        <div class="form-div p-3">
          <label for="ordenacaoOrientacao" class="form-label">Orientação da Ordenação <span
              matTooltip="Informar se o valor é decrescente ou crescente "><i
                class="fas fa-question-circle"></i></span><span class="required">*</span></label>
          <select #mySelectOrdem class="form-select" [(ngModel)]="novoItem.ordenacaoOrientacao"
            name="ordenacaoOrientacao">
            <option value="DESC">DECRESCENTE (maior para menor)</option>
            <option value="CRES">CRESCENTE (menor para maior)</option>
          </select>
        </div>
        <div class="form-div p-3">
          <label for="tipoResultado" class="form-label">Tipo Resultado <span
              matTooltip="Escolha o tipo de resultado (ex: Hora, Porcentagem) de acordo com os dados retornados pela consulta (query)."><i
                class="fas fa-question-circle"></i></span></label>
          <select class="form-select" (change)="mostrarCampoValorNocabecalho()" [(ngModel)]="novoItem.tipoResultado"
            name="tipoResultado">
            <option *ngFor="let tipoResultado of options" [value]="tipoResultado.value">{{ tipoResultado.label }}
            </option>
          </select>
        </div>
        <div *ngIf="this.EhPorcentagem" class="form-div form-check form-switch"
          style=" padding-left: 56px !important;  padding-bottom: 2.5em;">
          <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.valoresPorcentagemCabecalho"
            name="valoresPorcentagemCabecalho" id="valoresPorcentagemCabecalho">
          <label class="form-check-label" for="flexCheckDefault">
            Adicionar o nominador e o denominador no cabeçalho
          </label>
        </div>

        @if(novoItem.temCabecalhoEspecial)
        {
        <div [style.background-color]="CorCabecalhoEspecial" id="sessao_cabecalho_especial" style="color: black">
          <div style="display: flex; justify-content: right;">
            <button (click)="mudarRegistroComCabecalhoEspecial(false)" class="btn btn-danger"
              matTooltip="criação de Cabeçalho">Fechar Cabeçalho Especial</button>

          </div>
          <div class="form-div p-3">
            <label for="tipoValoresCabecalho" class="form-label">Tipo de get do Valor Cabeçalho: <span
                matTooltip="Escolha onde os valores que deve ser mostrado no cabelho devem ser pegos"><i
                  class="fas fa-question-circle"></i></span></label>
            <select class="form-select" [(ngModel)]="novoItem.tipoValoresCabecalho" name="tipoValoresCabecalho">
              <option *ngFor="let tipoCabecalho of optionsTipoCabecalho" [value]="tipoCabecalho.value">{{
                tipoCabecalho.label }}
              </option>
            </select>
            <p>Não selecionar o tipo "Calculo de cor" se não tiver multiplas consultas na sessão Calculo de cor</p>
          </div>
          <label for="variavelCabecalho" class="form-label">Variaveis para o Cabeçalho: </label>
          <div *ngFor="let variavel of variavelCabecalho; let i = index">
            <label for="variavel" class="form-label">Variavel {{i+1}}</label>
            @if(variavel.tipoResultadoCampo == 4)
            {
            <div class="form-div form-check form-switch" style="margin-left: 10px;">
              <input class="form-check-input" type="checkbox" [(ngModel)]="variavel.ehConsultaDerivada"
                name="var_ehConsultaDerivada_{{i}}" id="var_ehConsultaDerivada_{{i}}">
              <label class="form-check-label" for="flexCheckDefault">
                É uma consulta derivada de outra variavel do tipo "Nova Consulta" <span
                  matTooltip="Dar check se é uma consulta derivada"><i class="fas fa-question-circle"></i></span>
              </label>
            </div>
            @if(!variavel.ehConsultaDerivada){
              <div style="display: flex; justify-content: right; margin-top: 15px;">
            <button (click)="validateAndFormat(i, 'VariavelCabecalho')" class="btn btn-secondary" matTooltip="Validar o formato json é válido">Validar e Formatar
              JSON</button></div>
            <div class="form-div p-3">
              <label for="consulta" class="form-label">Consulta: <span
                  matTooltip="Criação da consulta Elasticsearch com paremetros  de data inicio e data fim e alguns parametros descrito abaixo "><i
                    class="fas fa-question-circle"></i></span></label>
              <textarea class="form-control" id="var_consulta_{{i}}" name="var_consulta_{{i}}"
                [(ngModel)]="variavel.consulta" required></textarea>
              <div id="consultaHelpBlock1" class="form-text">
                Utilize esses parâmentros para indicar data: #sc:inicio_dia#; #sc:fim_dia#; #sc:data_atual#; ou para
                filtrar por id: #sc:id#;<br />
                A variavel #sc:data_atual# pode ser implementada como #sc:data_atual-Xh#, #sc:data_atual+Xmin#,
                #sc:data_atual-Xs# altereando o X para um número necessário.
              </div>
            </div>
            <div class="form-div p-3">
              <label for="indice" class="form-label">Indice: <span matTooltip="indice da consulta"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="var_indice_{{i}}" name="var_indice_{{i}}"
                [(ngModel)]="variavel.indice" required>
            </div>
            }
            }
            <div class="form-div p-3">
              <label for="titulo" class="form-label">Titulo: <span matTooltip="Nome à aparecer no cabelho"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="var_titulo_{{i}}" name="var_titulo_{{i}}"
                [(ngModel)]="variavel.titulo" required>
            </div>
            <div class="form-div p-3">
              <label for="textoCampo" class="form-label">Texto do Campo: <span
                  matTooltip="Nome do indice no banco de dados "><i class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="var_textoCampo_{{i}}" name="var_textoCampo_{{i}}"
                [(ngModel)]="variavel.textoCampo" required>
            </div>
            <div class="form-div p-3">
              <label for="ordem" class="form-label">Ordem: <span matTooltip="Ordem que aparecerá no cabeçalho"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="var_ordem_{{i}}" name="var_ordem_{{i}}"
                [(ngModel)]="variavel.ordem" required>
            </div>
            <div class="form-div p-3">
              <label for="tipoResultado" class="form-label">Tipo Resultado do Campo<span
                  matTooltip="Tipo de resultado que será exibido, de acordo com o retorno da query: Padrão, Hora, Milissegundos ou Porcentagem (%)."><i
                    class="fas fa-question-circle"></i></span></label>
              <select class="form-select" [(ngModel)]="variavel.tipoResultadoCampo" name="var_tipoResultadoCampo_{{i}}">
                <option *ngFor="let tipoResultado of optionsTipoResultadoCampoVariavel" [value]="tipoResultado.value">{{
                  tipoResultado.label }}
                </option>
              </select>
            </div>
            <div class="form-div p-3" *ngIf="variavel.tipoResultadoCampo != 1">
              <label for="tipoResultado" class="form-label">Tipo Resultado da variavel<span
                  matTooltip="Tipo de resultado que será exibido, de acordo com o retorno da query: Padrão, Hora, Milissegundos ou Porcentagem (%)."><i
                    class="fas fa-question-circle"></i></span></label>
              <select class="form-select" [(ngModel)]="variavel.tipoResultado" name="var_tipoResultado_{{i}}">
                <option *ngFor="let tipoResultado of optionsVariavel" [value]="tipoResultado.value">{{
                  tipoResultado.label
                  }}
                </option>
              </select>
            </div>

            <button (click)="removerVariavelCabecalho(i)" class="btn btn-secondary"
              style="margin-left: 15px;margin-right: 15px;">Remover Variavel</button>
            <hr>
          </div>

          <button (click)="adicionarVariavelCabecalho()" class="btn btn-info" style="margin-left: 15px;">Adicionar
            Variavel</button>
          <button (click)="getVariavelCabecalhoIndicadorEtapa1()" *ngIf="!EhEtapa1" class="btn btn-secondary"
            style="margin-left: 15px;margin-right: 15px;">Copiar Regra do Indicador da Etapa 1</button>
        </div>
        }
        @else{
        @if(novoItem.etapa!=3){
        <div style="display: flex; justify-content: right;">
          <button (click)="mudarRegistroComCabecalhoEspecial(true)" id="sessao_cabecalho_especial"
            class="btn btn-secondary" matTooltip="criação de Cabeçalho">Abrir Cabeçalho Especial</button>
        </div>
        }
        }

        <hr>
        <!--CALCULO DE COR AQUI-->
        <div [style.background-color]="CorCalculoCor" style="color: black" id="sessao_calculo_cor">
          <label for="calculoCores" class="form-label">Cálculo de Cores: </label>
          <div *ngFor="let consulta of consultasCor; let i = index">
            <label for="consulta" class="form-label">Consulta {{i+1}}</label>
            <div class="form-div p-3">
              <label for="nome" class="form-label">Nome: <span matTooltip="Nome da consulta EX: Regra de cor"><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="c_nome_{{i}}" name="c_nome_{{i}}" [(ngModel)]="consulta.nome"
                [readonly]="consulta.nome == 'Regra de Valor' || consulta.nome == 'Regra de Retorno da Formula'"
                required>
            </div>
            <div class="form-div p-3" *ngIf="!consulta.nome.includes('Regra')">
              <label for="nome" class="form-label">Índice: <span matTooltip="Nome do indice no banco de dados "><i
                    class="fas fa-question-circle"></i></span></label>
              <input type="text" class="form-control" id="c_indice_{{i}}" name="c_indice_{{i}}"
                [(ngModel)]="consulta.indice" required>
            </div>
            <div style="display: flex; justify-content: right; margin-top: 15px;">
            <button (click)="validateAndFormat(i, 'CORES')" class="btn btn-secondary" matTooltip="Verificar se o json é Válido">Validar e Formatar
              JSON</button></div>
            <div class="form-div p-3">
              <label for="consulta" class="form-label">Consulta: <span
                  matTooltip="Query utilizada na pesquisa em formato de json valido"><i
                    class="fas fa-question-circle"></i></span></label>
              <textarea class="form-control" id="c_consulta_{{i}}" name="c_consulta_{{i}}"
                [(ngModel)]="consulta.consulta" required></textarea>
              <div id="consultaHelpBlock1" class="form-text">
                Utilize esses parâmentros para indicar data: #sc:inicio_dia#; #sc:fim_dia#; #sc:data_atual#; ou para
                filtrar por id: #sc:id#;<br />
                A variavel #sc:data_atual# pode ser implementada como #sc:id#, #sc:data_atual-Xh#, #sc:data_atual+Xmin#,
                #sc:data_atual-Xs# altereando o X para um número necessário.
              </div>
              <div id="consultaHelpBlock2" *ngIf="EhCalculoCorPadrao !== 0 && consulta.nome.includes('Regra')"
                class="form-text">
                Altere os valores equivalentes do periodo para cada cor no lugar de NumeroMaior e NumeroMenor (se for um
                numero quebrado utilizar ponto - ex: 9,99 será 9.99)
              </div>
            </div>
            <div class="form-div p-3" *ngIf="!consulta.nome.includes('Regra')">
              <label for="tipoResultado" class="form-label">Tipo Resultado <span
                  matTooltip="Tipo de resultado que será exibido, de acordo com o retorno da query: Padrão, Hora, Milissegundos ou Porcentagem (%)."><i
                    class="fas fa-question-circle"></i></span></label>
              <select class="form-select" [(ngModel)]="consulta.tipoResultado" name="c_tipoResultado_{{i}}">
                <option *ngFor="let tipoResultado of options" [value]="tipoResultado.value">{{ tipoResultado.label }}
                </option>
              </select>
            </div>

            <div style="display: flex; justify-content: space-between;  margin: 15px">
              <button (click)="getCalculoCorIndicadorEtapa1()" *ngIf="!EhEtapa1" class="btn btn-secondary">Copiar Regra
                do Indicador da Etapa 1</button>
              <div class="dropdown" (click)="toggleDropdown()">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Setar Regra Padrão
                </button>
                <div class="dropdown-menu" [class.show]="isDropdownOpen" (click)="handleDropdownItemClick($event)"
                  aria-labelledby="dropdownMenu2">
                  <button class="dropdown-item" type="button" (click)="SetarRegraPadrao(consulta, true)">Pelo Valor do
                    Indicador</button>
                  <button class="dropdown-item" type="button" (click)="SetarRegraDoValorDasFormula(consulta, true)">Pelo
                    Valor da
                    Formula</button>
                  <button class="dropdown-item" type="button" (click)="SetarRegraCampos(consulta)">Pelo Valor para
                    Campos</button>
                </div>
              </div>


            </div>
            <div style="display: flex; justify-content: space-between;  margin: 15px">
              <button (click)="removerConsultaCor(i,consulta)" class="btn btn-secondary"
                style="margin-left: 15px;margin-right: 15px;">Remover Consulta</button>

              <button (click)="CancelarRegraPadrao(consulta)"
                *ngIf="EhCalculoCorPadrao!==0 && consulta.nome.includes('Regra')" class="btn btn-danger">Cancelar Regra
                Padrao</button>
            </div>
            <hr>
          </div>
          <div class="form-div p-3" *ngIf="EhCalculoCorPadrao == 2">
            <label for="formula" class="form-label">Formula para o Cálculo de Cor:</label>
            <input type="text" class="form-control" id="formula" name="formula" [(ngModel)]="novoItem.formula" required>
          </div>
          <div class="form-div form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.temRegraAberturaFechamento"
              name="temRegraAberturaFechamento" id="temRegraAberturaFechamento">
            <label class="form-check-label" for="flexCheckDefault">
              tem a regra de cor de fechamento e abertura de posto?
            </label>
          </div>
          <div class="form-div form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.temChegagemStatusPostoAgenda"
              name="temChegagemStatusPostoAgenda" id="temChegagemStatusPostoAgenda">
            <label class="form-check-label" for="flexCheckDefault">
              Inativar posto checando o status do posto de acordo com a agenda?
            </label>
          </div>
          <button (click)="adicionarConsultaCor()" *ngIf="EhCalculoCorPadrao !== 1" class="btn btn-info"
            style="margin-left: 15px;">Adicionar Consulta</button>
          <div class="form-div p-3">
            <label for="corDefault" class="form-label">Cor Default(Caso vir sem Dados): <span class="required">* </span>
              <span matTooltip="Qual a cor que será padrão caso não tenha dados a serem mostrados?"><i
                  class="fas fa-question-circle"></i></span>
            </label>
            <input type="text" class="form-control" id="corDefault" name="corDefault" [(ngModel)]="novoItem.corDefault"
              required>
          </div>
          <div class="form-div p-3" *ngIf="EhPorcentagem && !EhMultiConsultaValor">
            <label for="corDefaultDenominador" class="form-label">Cor Default Denominador(Caso Denominador !=0 e
              Nominador=0):</label>
            <input type="text" class="form-control" id="corDefaultDenominador" name="corDefaultDenominador"
              [(ngModel)]="novoItem.corDefaultDenominador">
          </div>
          <!--<div class="form-div p-3" *ngIf="EhPorcentagem && !EhMultiConsultaValor">
          <label for="corDefaultNominador" class="form-label">Cor Default Nominador(Caso Denominador =0 e Nominador!=0):</label>
          <input type="text" class="form-control" id="corDefaultNominador" name="corDefaultNominador" [(ngModel)]="novoItem.corDefaultNominador">
        </div>-->
          <div class="form-div p-3" *ngIf="EhPorcentagem && !EhMultiConsultaValor">
            <label for="corDefaultZero" class="form-label">Cor Default Tudo 0(Caso Denominador =0 e
              Nominador=0):</label>
            <input type="text" class="form-control" id="corDefaultZero" name="corDefaultZero"
              [(ngModel)]="novoItem.corDefaultZero">
          </div>
        </div>

        <hr>
        <!--FAROL AQUI-->
        <div [style.background-color]="CorFarol" style="color: black;" id="sessao_cor_farol">
          <label for="calculoCores" class="form-label">Cálculo do Farol:</label>
          <div class="form-div p-3" style=" padding-left: 56px !important;  padding-bottom: 2.5em; display: flex;">
            <div class="form-div form-check form-switch">
              <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.desabilitarFarol"
                name="desabilitarFarol" id="desabilitarFarol">
              <label class="form-check-label" for="flexCheckDefault">
                Desabilitar Farol?
              </label>
            </div>
          </div>
          <div class="form-div p-3" style=" padding-left: 56px !important; display: flex;">
            <div class="form-div form-check form-switch">
              <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.farolCorPrincipal"
                name="farolCorPrincipal" id="farolCorPrincipal">
              <label class="form-check-label" for="flexCheckDefault">
                Farol vai ser a cor Principal? <span matTooltip="A cor do farol será a cor principal do indicador"><i
                    class="fas fa-question-circle"></i></span>
              </label>
            </div>

          </div>


          <button (click)="AbrirCopiaFarol()" class="btn btn-info" style="margin-left: 15px;">Copiar Farol de outro
            Indicador</button>
          <div class="form-div p-3" [style.display]="EhFarolCopia ? 'block' : 'none'">
            <label for="indicador" class="form-label">De qual Indicador vai copiar? <span
                matTooltip="Escolha o indicador que você quer copiar o farol"><i
                  class="fas fa-question-circle"></i></span>
            </label>
            <select #mySelectIndicadorCopiaFarol name="select" class="form-select"
              (change)="onOptionChangeCopiaFarol(mySelectIndicadorCopiaFarol.value)">
              <option value="">Escolha o Indicador</option>
              <option *ngFor="let objeto of listaIndAllEtapasComFarol" value={{objeto.id}}>{{objeto.etapa}} -
                {{objeto.nome}}
              </option>

            </select>
            <button (click)="CopiarFarol()" class="btn btn-info">Copiar Farol</button>
          </div>
          <div *ngFor="let consulta of consultasFarol; let i = index">
            <label for="consulta" class="form-label">Consulta {{i+1}}</label>
            <div class="form-div p-3">
              <label for="nome" class="form-label">Nome: <span
                  matTooltip="Nome da consulta para o farol EX: Consulta Farol"><i
                    class="fas fa-question-circle"></i></span>
              </label>
              <input type="text" class="form-control" id="f_nome_{{i}}" name="f_nome_{{i}}" [(ngModel)]="consulta.nome"
                [readonly]="consulta.nome == 'Regra de Valor' || consulta.nome == 'Regra de Retorno da Formula'"
                required>
            </div>
            <div class="form-div p-3" *ngIf="!consulta.nome.includes('Regra')">
              <label for="nome" class="form-label">Índice: <span matTooltip="Nome do índice do banco"><i
                    class="fas fa-question-circle"></i></span>
              </label>
              <input type="text" class="form-control" id="f_indice_{{i}}" name="f_indice_{{i}}"
                [(ngModel)]="consulta.indice" required>
            </div>
            <div style="display: flex; justify-content: right; margin-top: 15px;">
            <button (click)="validateAndFormat(i, 'FAROL')" class="btn btn-secondary"
              matTooltip="Validando se o formato json é correto" >Validar e
              Formatar JSON
            </button></div>
            <div class="form-div p-3">
              <label for="consulta" class="form-label">Consulta: <span
                  matTooltip="Query utilizada no Elasticsearch para fazer a busca da informação"><i
                    class="fas fa-question-circle"></i></span>
              </label>
              <textarea class="form-control" id="f_consulta_{{i}}" name="f_consulta_{{i}}"
                [(ngModel)]="consulta.consulta" required></textarea>
              <div id="consultaHelpBlock1" class="form-text">
                Utilize esses parâmentros para indicar data: #sc:inicio_dia#; #sc:fim_dia#; #sc:data_atual#; ou para
                filtrar por id: #sc:id#;<br />
                A variável #sc:data_atual# pode ser implementada como #sc:id#, #sc:data_atual-Xh#, #sc:data_atual+Xmin#,
                #sc:data_atual-Xs# altereando o X para um número necessário.
              </div>
              <div id="consultaHelpBlock2" *ngIf="EhCalculoCorPadrao !== 0 && consulta.nome.includes('Regra')"
                class="form-text">
                Altere os valores equivalentes do periodo para cada cor no lugar de NumeroMaior e NumeroMenor (se for um
                numero quebrado utilizar ponto - ex: 9,99 será 9.99)
              </div>
            </div>
            <div class="form-div p-3" *ngIf="!consulta.nome.includes('Regra')">
              <label for="tipoResultado" class="form-label">Tipo Resultado <span
                  matTooltip="Tipo de Resultado que será mostrado Padrão, Hora , milisegundos e Porcentagem % "><i
                    class="fas fa-question-circle"></i></span>
              </label>
              <select class="form-select" [(ngModel)]="consulta.tipoResultado" name="f_tipoResultado_{{i}}">
                <option *ngFor="let tipoResultado of options" [value]="tipoResultado.value">{{ tipoResultado.label }}
                </option>
              </select>
            </div>

            <div style="display: flex; justify-content: space-between; margin: 15px">
              <button (click)="getCalculoCorIndicadorEtapa1()" *ngIf="!EhEtapa1" class="btn btn-secondary">Copiar Regra
                do Indicador da Etapa 1</button>
              <div class="dropdown" (click)="toggleDropdown()">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Setar Regra Padrão
                </button>
                <div class="dropdown-menu" [class.show]="isDropdownOpen" (click)="handleDropdownItemClick($event)"
                  aria-labelledby="dropdownMenu2">
                  <button class="dropdown-item" type="button" (click)="SetarRegraPadrao(consulta, false)">Pelo Valor do
                    Indicador</button>
                  <button class="dropdown-item" type="button"
                    (click)="SetarRegraDoValorDasFormula(consulta, false)">Pelo
                    Valor da
                    Formula</button>
                </div>
              </div>

            </div>
            <div style="display: flex; justify-content: space-between;  margin: 15px">
              <button (click)="removerConsultaFarol(i,consulta)" class="btn btn-secondary">Remover Consulta</button>
              <button (click)="CancelarRegraPadrao(consulta)" *ngIf="consulta.nome.includes('Regra')"
                class="btn btn-danger">Cancelar Regra Padrao</button>
            </div>
            <hr>
          </div>
          <button (click)="adicionarConsultaFarol()" class="btn btn-info" style="margin-left: 15px;">Adicionar
            Consulta</button>
          <div class="form-div p-3">
            <label for="formulaCalculoFarol" class="form-label">Formula para o Cálculo do Farol: <span
                matTooltip="Monte a fórmula para o cálculo do farol de acordo com os campos que estão sendo retornado na query"><i
                  class="fas fa-question-circle"></i></span>
            </label>
            <input type="text" class="form-control" id="formulaCalculoFarol" name="formulaCalculoFarol"
              [(ngModel)]="novoItem.formulaCalculoFarol" required>
          </div>
          <div class="form-div p-3">
            <label for="tempoAtualizacaoCalculoFarol" class="form-label">Tempo mínimo de Atualização do Farol: <span
                matTooltip="Tempo em segundos que esse farol será atualizado"><i
                  class="fas fa-question-circle"></i></span>
            </label>
            <input type="text" class="form-control" id="tempoAtualizacaoCalculoFarol"
              name="tempoAtualizacaoCalculoFarol" [(ngModel)]="novoItem.tempoAtualizacaoCalculoFarol" required>
          </div>
          <div class="form-div p-3">
            <label for="tipoFinal" class="form-label">Tipo final do Farol: <span
                matTooltip="Escolha a última tela que o farol não irá aparecer"><i
                  class="fas fa-question-circle"></i></span>
            </label>
            <select class="form-select" [(ngModel)]="novoItem.tipoFinal" name="tipoFinal">
              <option value="posto">Posto</option>
              <option value="orgao">Orgao</option>
              <option value="servico">Serviço</option>
              <option value="fila">Fila</option>
            </select>
          </div>

          <div class="div-button mb-3 p-3">
            <button id="class-button"
              style="position: fixed; bottom: 58px; right: 220px;border-radius: 50%;width: 45px;height: 45px;"
              (click)="irPara('sessao_topo_tela')" class="btn btn-secondary"><i
                class="fa-solid fa-arrow-up"></i></button>
            <button *ngIf="novoItem.id != undefined && novoItem.inativo != true" id="class-button"
              style="position: fixed; bottom: 58px; right: 171px;border-radius: 50%;width: 45px;height: 45px;"
              (click)="InativarItem(novoItem.id)" class="btn btn-danger"><i class="fa-solid fa-trash-can"></i></button>
            <button *ngIf="novoItem.id != undefined && novoItem.inativo == true" id="class-button"
              style="position: fixed; bottom: 58px; right: 171px;border-radius: 50%;width: 45px;height: 45px;"
              (click)="AtivarItem(novoItem.id)" class="btn btn-success"><i class="fas fa-power-off"></i></button>
            <a style="margin-left: 80%;  margin-right: 10px;position: fixed; bottom: 58px; right: 111px;"
              [routerLink]="['/indicador-listagem']"><button id="class-button" class="btn btn-secondary"
                style="border-radius: 50%;width: 45px;height: 45px;"><i
                  class="fa-solid fa-rotate-left"></i></button></a>
            <button id="class-button"
              style="margin-right: 10px;position: fixed; bottom: 58px; right: 61px;border-radius: 50%;width: 45px;height: 45px;"
              (click)="Limpar()" class="btn btn-secondary"><i class="fa-solid fa-broom"></i></button>
            <button id="class-button"
              style="position: fixed; bottom: 58px; right: 22px;border-radius: 50%;width: 45px;height: 45px;"
              (click)="submitForm()" class="btn btn-primary"><i class="fa-solid fa-floppy-disk"></i></button>
          </div>
        </div>
      </form>
    </section>
  </main>
</section>